import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class IconButton extends React.Component {
    onClick = () => {
        this.props.onClick()
    }

    render() {
        return (
            <button
                style={this.props.style}
                onClick={this.onClick}
                className="icon-btn"
                disabled={this.props.disabled}
                pressed={this.props.pressed}>
                <FontAwesomeIcon
                    className={this.props.pressed ? 'text-primary' : ''}
                    icon={this.props.icon}
                />
            </button>
        )
    }
}
